export interface IEnkFieldSetProps {
  label: string
  description?: string
  children: React.ReactNode
  className?: string
}

export function EnkFieldSet(props: IEnkFieldSetProps) {
  const { label, description, children, className } = props
  return (
    <fieldset className={className}>
      <legend className="text-sm font-semibold leading-6 text-gray-900">{label}</legend>
      {description && <p className="mt-1 text-sm leading-6 text-gray-600">{description}</p>}
      <div className="mt-6 space-y-6">{children}</div>
    </fieldset>
  )
}
